import 'core-js/modules/es6.reflect.construct.js';
import 'core-js/modules/es6.object.keys.js';
import 'core-js/modules/es6.symbol.js';
import 'core-js/modules/es6.array.filter.js';
import 'core-js/modules/es6.object.get-own-property-descriptor.js';
import 'core-js/modules/es7.object.get-own-property-descriptors.js';
import _extends from '@babel/runtime/helpers/esm/extends';
import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _get from '@babel/runtime/helpers/esm/get';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import 'core-js/modules/es6.array.map.js';
import cx from 'classnames';
import * as React from 'react';
import DayPicker from 'react-day-picker';
import { Divider, Button, AbstractPureComponent2, DISPLAYNAME_PREFIX } from '@blueprintjs/core';
import { DATEPICKER_DAY_WRAPPER, DATEPICKER, DATEPICKER_FOOTER, DATEPICKER_TIMEPICKER_WRAPPER } from './common/classes.js';
import { isToday, isDayInRange, getDateTime, isMonthInRange, areSameDay, getDateBetween } from './common/dateUtils.js';
import { DATEPICKER_DEFAULT_VALUE_INVALID, DATEPICKER_INITIAL_MONTH_INVALID, DATEPICKER_MAX_DATE_INVALID, DATEPICKER_VALUE_INVALID } from './common/errors.js';
import { DatePickerCaption } from './datePickerCaption.js';
import { getDefaultMaxDate, getDefaultMinDate } from './datePickerCore.js';
import { DatePickerNavbar } from './datePickerNavbar.js';
import { Shortcuts } from './shortcuts.js';
import { TimePicker } from './timePicker.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var DatePicker = /*#__PURE__*/function (_AbstractPureComponen) {
  _inherits(DatePicker, _AbstractPureComponen);

  var _super = _createSuper(DatePicker);

  function DatePicker(_props, context) {
    var _this;

    _classCallCheck(this, DatePicker);

    _this = _super.call(this, _props, context);
    _this.ignoreNextMonthChange = false;

    _this.shouldHighlightCurrentDay = function (date) {
      var highlightCurrentDay = _this.props.highlightCurrentDay;
      return highlightCurrentDay && isToday(date);
    };

    _this.getDatePickerModifiers = function () {
      var modifiers = _this.props.modifiers;
      return _objectSpread({
        isToday: _this.shouldHighlightCurrentDay
      }, modifiers);
    };

    _this.renderDay = function (day) {
      var date = day.getDate();
      return /*#__PURE__*/React.createElement("div", {
        className: DATEPICKER_DAY_WRAPPER
      }, date);
    };

    _this.disabledDays = function (day) {
      return !isDayInRange(day, [_this.props.minDate, _this.props.maxDate]);
    };

    _this.getDisabledDaysModifier = function () {
      var _ref = _this.props,
          disabledDays = _ref.dayPickerProps.disabledDays;
      return Array.isArray(disabledDays) ? [_this.disabledDays].concat(_toConsumableArray(disabledDays)) : [_this.disabledDays, disabledDays];
    };

    _this.renderCaption = function (props) {
      return /*#__PURE__*/React.createElement(DatePickerCaption, _extends({}, props, {
        maxDate: _this.props.maxDate,
        minDate: _this.props.minDate,
        onDateChange: _this.handleMonthChange,
        reverseMonthAndYearMenus: _this.props.reverseMonthAndYearMenus
      }));
    };

    _this.renderNavbar = function (props) {
      return /*#__PURE__*/React.createElement(DatePickerNavbar, _extends({}, props, {
        maxDate: _this.props.maxDate,
        minDate: _this.props.minDate
      }));
    };

    _this.handleDayClick = function (day, modifiers, e) {
      var _this$props$dayPicker, _this$props$dayPicker2;

      (_this$props$dayPicker = _this.props.dayPickerProps) === null || _this$props$dayPicker === void 0 ? void 0 : (_this$props$dayPicker2 = _this$props$dayPicker.onDayClick) === null || _this$props$dayPicker2 === void 0 ? void 0 : _this$props$dayPicker2.call(_this$props$dayPicker, day, modifiers, e);

      if (modifiers.disabled) {
        return;
      }

      _this.updateDay(day); // allow toggling selected date by clicking it again (if prop enabled)


      var newValue = _this.props.canClearSelection && modifiers.selected ? null : getDateTime(day, _this.state.value);

      _this.updateValue(newValue, true);
    };

    _this.handleShortcutClick = function (shortcut, selectedShortcutIndex) {
      var _this$props = _this.props,
          onShortcutChange = _this$props.onShortcutChange,
          currentShortcutIndex = _this$props.selectedShortcutIndex;
      var dateRange = shortcut.dateRange,
          includeTime = shortcut.includeTime;
      var newDate = dateRange[0];
      var newValue = includeTime ? newDate : getDateTime(newDate, _this.state.value);

      _this.updateDay(newDate);

      _this.updateValue(newValue, true);

      if (currentShortcutIndex === undefined) {
        _this.setState({
          selectedShortcutIndex: selectedShortcutIndex
        });
      }

      var datePickerShortcut = _objectSpread(_objectSpread({}, shortcut), {}, {
        date: shortcut.dateRange[0]
      });

      onShortcutChange === null || onShortcutChange === void 0 ? void 0 : onShortcutChange(datePickerShortcut, selectedShortcutIndex);
    };

    _this.updateDay = function (day) {
      if (_this.props.value === undefined) {
        // set now if uncontrolled, otherwise they'll be updated in `componentDidUpdate`
        _this.setState({
          displayMonth: day.getMonth(),
          displayYear: day.getFullYear(),
          selectedDay: day.getDate()
        });
      }

      if (_this.state.value != null && _this.state.value.getMonth() !== day.getMonth()) {
        _this.ignoreNextMonthChange = true;
      }
    };

    _this.handleClearClick = function () {
      return _this.updateValue(null, true);
    };

    _this.handleMonthChange = function (newDate) {
      var _this$props$dayPicker3, _this$props$dayPicker4;

      var date = _this.computeValidDateInSpecifiedMonthYear(newDate.getFullYear(), newDate.getMonth());

      _this.setState({
        displayMonth: date.getMonth(),
        displayYear: date.getFullYear()
      });

      if (_this.state.value !== null) {
        // if handleDayClick just got run (so this flag is set), then the
        // user selected a date in a new month, so don't invoke onChange a
        // second time
        _this.updateValue(date, false, _this.ignoreNextMonthChange);

        _this.ignoreNextMonthChange = false;
      }

      (_this$props$dayPicker3 = _this.props.dayPickerProps) === null || _this$props$dayPicker3 === void 0 ? void 0 : (_this$props$dayPicker4 = _this$props$dayPicker3.onMonthChange) === null || _this$props$dayPicker4 === void 0 ? void 0 : _this$props$dayPicker4.call(_this$props$dayPicker3, date);
    };

    _this.handleTodayClick = function () {
      var value = new Date();
      var displayMonth = value.getMonth();
      var displayYear = value.getFullYear();
      var selectedDay = value.getDate();

      _this.setState({
        displayMonth: displayMonth,
        displayYear: displayYear,
        selectedDay: selectedDay
      });

      _this.updateValue(value, true);
    };

    _this.handleTimeChange = function (time) {
      var _this$props$timePicke, _this$props$timePicke2;

      (_this$props$timePicke = _this.props.timePickerProps) === null || _this$props$timePicke === void 0 ? void 0 : (_this$props$timePicke2 = _this$props$timePicke.onChange) === null || _this$props$timePicke2 === void 0 ? void 0 : _this$props$timePicke2.call(_this$props$timePicke, time);
      var value = _this.state.value;
      var newValue = getDateTime(value != null ? value : new Date(), time);

      _this.updateValue(newValue, true);
    };

    var _value = getInitialValue(_props);

    var initialMonth = getInitialMonth(_props, _value);
    _this.state = {
      displayMonth: initialMonth.getMonth(),
      displayYear: initialMonth.getFullYear(),
      selectedDay: _value == null ? null : _value.getDate(),
      selectedShortcutIndex: _this.props.selectedShortcutIndex !== undefined ? _this.props.selectedShortcutIndex : -1,
      value: _value
    };
    return _this;
  }

  _createClass(DatePicker, [{
    key: "render",
    value: function render() {
      var _dayPickerProps$rende;

      var _this$props2 = this.props,
          className = _this$props2.className,
          dayPickerProps = _this$props2.dayPickerProps,
          locale = _this$props2.locale,
          localeUtils = _this$props2.localeUtils,
          maxDate = _this$props2.maxDate,
          minDate = _this$props2.minDate,
          showActionsBar = _this$props2.showActionsBar;
      var _this$state = this.state,
          displayMonth = _this$state.displayMonth,
          displayYear = _this$state.displayYear;
      return /*#__PURE__*/React.createElement("div", {
        className: cx(DATEPICKER, className)
      }, this.maybeRenderShortcuts(), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DayPicker, _extends({
        showOutsideDays: true,
        locale: locale,
        localeUtils: localeUtils,
        modifiers: this.getDatePickerModifiers()
      }, dayPickerProps, {
        canChangeMonth: true,
        captionElement: this.renderCaption,
        navbarElement: this.renderNavbar,
        disabledDays: this.getDisabledDaysModifier(),
        fromMonth: minDate,
        month: new Date(displayYear, displayMonth),
        onDayClick: this.handleDayClick,
        onMonthChange: this.handleMonthChange,
        selectedDays: this.state.value,
        toMonth: maxDate,
        renderDay: (_dayPickerProps$rende = dayPickerProps === null || dayPickerProps === void 0 ? void 0 : dayPickerProps.renderDay) !== null && _dayPickerProps$rende !== void 0 ? _dayPickerProps$rende : this.renderDay
      })), this.maybeRenderTimePicker(), showActionsBar && this.renderOptionsBar()));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      _get(_getPrototypeOf(DatePicker.prototype), "componentDidUpdate", this).call(this, prevProps, prevState);

      var value = this.props.value;

      if (value === prevProps.value) {
        // no action needed
        return;
      } else if (value == null) {
        // clear the value
        this.setState({
          value: value
        });
      } else {
        this.setState({
          displayMonth: value.getMonth(),
          displayYear: value.getFullYear(),
          selectedDay: value.getDate(),
          value: value
        });
      }

      if (this.props.selectedShortcutIndex !== prevProps.selectedShortcutIndex) {
        this.setState({
          selectedShortcutIndex: this.props.selectedShortcutIndex
        });
      }
    }
  }, {
    key: "validateProps",
    value: function validateProps(props) {
      var defaultValue = props.defaultValue,
          initialMonth = props.initialMonth,
          maxDate = props.maxDate,
          minDate = props.minDate,
          value = props.value;

      if (defaultValue != null && !isDayInRange(defaultValue, [minDate, maxDate])) {
        console.error(DATEPICKER_DEFAULT_VALUE_INVALID);
      }

      if (initialMonth != null && !isMonthInRange(initialMonth, [minDate, maxDate])) {
        console.error(DATEPICKER_INITIAL_MONTH_INVALID);
      }

      if (maxDate != null && minDate != null && maxDate < minDate && !areSameDay(maxDate, minDate)) {
        console.error(DATEPICKER_MAX_DATE_INVALID);
      }

      if (value != null && !isDayInRange(value, [minDate, maxDate])) {
        console.error(DATEPICKER_VALUE_INVALID);
      }
    }
  }, {
    key: "renderOptionsBar",
    value: function renderOptionsBar() {
      var _this$props3 = this.props,
          clearButtonText = _this$props3.clearButtonText,
          todayButtonText = _this$props3.todayButtonText;
      return [/*#__PURE__*/React.createElement(Divider, {
        key: "div"
      }), /*#__PURE__*/React.createElement("div", {
        className: DATEPICKER_FOOTER,
        key: "footer"
      }, /*#__PURE__*/React.createElement(Button, {
        minimal: true,
        onClick: this.handleTodayClick,
        text: todayButtonText
      }), /*#__PURE__*/React.createElement(Button, {
        minimal: true,
        onClick: this.handleClearClick,
        text: clearButtonText
      }))];
    }
  }, {
    key: "maybeRenderTimePicker",
    value: function maybeRenderTimePicker() {
      var _this$props4 = this.props,
          timePrecision = _this$props4.timePrecision,
          timePickerProps = _this$props4.timePickerProps,
          minDate = _this$props4.minDate,
          maxDate = _this$props4.maxDate;

      if (timePrecision == null && timePickerProps === DatePicker.defaultProps.timePickerProps) {
        return null;
      }

      var applyMin = areSameDay(this.state.value, minDate);
      var applyMax = areSameDay(this.state.value, maxDate);
      return /*#__PURE__*/React.createElement("div", {
        className: DATEPICKER_TIMEPICKER_WRAPPER
      }, /*#__PURE__*/React.createElement(TimePicker, _extends({
        precision: timePrecision,
        minTime: applyMin ? minDate : undefined,
        maxTime: applyMax ? maxDate : undefined
      }, timePickerProps, {
        onChange: this.handleTimeChange,
        value: this.state.value
      })));
    }
  }, {
    key: "maybeRenderShortcuts",
    value: function maybeRenderShortcuts() {
      var shortcuts = this.props.shortcuts;

      if (shortcuts == null || shortcuts === false) {
        return null;
      }

      var selectedShortcutIndex = this.state.selectedShortcutIndex;
      var _this$props5 = this.props,
          maxDate = _this$props5.maxDate,
          minDate = _this$props5.minDate,
          timePrecision = _this$props5.timePrecision; // Reuse the existing date range shortcuts and only care about start date

      var dateRangeShortcuts = shortcuts === true ? true : shortcuts.map(function (shortcut) {
        return _objectSpread(_objectSpread({}, shortcut), {}, {
          dateRange: [shortcut.date, undefined]
        });
      });
      return [/*#__PURE__*/React.createElement(Shortcuts, {
        key: "shortcuts",
        allowSingleDayRange: true,
        maxDate: maxDate,
        minDate: minDate,
        selectedShortcutIndex: selectedShortcutIndex,
        shortcuts: dateRangeShortcuts,
        timePrecision: timePrecision,
        onShortcutClick: this.handleShortcutClick,
        useSingleDateShortcuts: true
      }), /*#__PURE__*/React.createElement(Divider, {
        key: "div"
      })];
    }
  }, {
    key: "computeValidDateInSpecifiedMonthYear",
    value: function computeValidDateInSpecifiedMonthYear(displayYear, displayMonth) {
      var _this$props6 = this.props,
          minDate = _this$props6.minDate,
          maxDate = _this$props6.maxDate;
      var selectedDay = this.state.selectedDay; // month is 0-based, date is 1-based. date 0 is last day of previous month.

      var maxDaysInMonth = new Date(displayYear, displayMonth + 1, 0).getDate();
      var displayDate = selectedDay == null ? 1 : Math.min(selectedDay, maxDaysInMonth); // 12:00 matches the underlying react-day-picker timestamp behavior

      var value = getDateTime(new Date(displayYear, displayMonth, displayDate, 12), this.state.value); // clamp between min and max dates

      if (value < minDate) {
        return minDate;
      } else if (value > maxDate) {
        return maxDate;
      }

      return value;
    }
  }, {
    key: "updateValue",
    value:
    /**
     * Update `value` by invoking `onChange` (always) and setting state (if uncontrolled).
     */
    function updateValue(value, isUserChange) {
      var skipOnChange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (!skipOnChange) {
        var _this$props$onChange, _this$props7;

        (_this$props$onChange = (_this$props7 = this.props).onChange) === null || _this$props$onChange === void 0 ? void 0 : _this$props$onChange.call(_this$props7, value, isUserChange);
      }

      if (this.props.value === undefined) {
        this.setState({
          value: value
        });
      }
    }
  }]);

  return DatePicker;
}(AbstractPureComponent2);
DatePicker.defaultProps = {
  canClearSelection: true,
  clearButtonText: "Clear",
  dayPickerProps: {},
  highlightCurrentDay: false,
  maxDate: getDefaultMaxDate(),
  minDate: getDefaultMinDate(),
  reverseMonthAndYearMenus: false,
  shortcuts: false,
  showActionsBar: false,
  timePickerProps: {},
  todayButtonText: "Today"
};
DatePicker.displayName = "".concat(DISPLAYNAME_PREFIX, ".DatePicker");

function getInitialValue(props) {
  // !== because `null` is a valid value (no date)
  if (props.value !== undefined) {
    return props.value;
  }

  if (props.defaultValue !== undefined) {
    return props.defaultValue;
  }

  return null;
}

function getInitialMonth(props, value) {
  var today = new Date(); // != because we must have a real `Date` to begin the calendar on.

  if (props.initialMonth != null) {
    return props.initialMonth;
  } else if (value != null) {
    return value;
  } else if (isDayInRange(today, [props.minDate, props.maxDate])) {
    return today;
  } else {
    return getDateBetween([props.minDate, props.maxDate]);
  }
}

export { DatePicker };
//# sourceMappingURL=datePicker.js.map
